import App from '@/App.tsx'
import {
  action as bmiCalculatorAction,
  BMICalculator,
} from '@/screens/velthuis/BMICalculator'
import { BMIHigh } from '@/screens/velthuis/BMIHigh/BMIHigh'
import { ConfirmBooking } from '@/screens/velthuis/ConfirmBooking'
import { ErrorScreen } from '@/screens/velthuis/ErrorScreen.tsx'
import { HealthWarning } from '@/screens/velthuis/HealthWarning/HealthWarning'
import {
  action as savePatientDetailsAndCreateAppointmentAction,
  PatientDetails,
} from '@/screens/velthuis/PatientDetails'
import {
  loader as proposedAppointmentLoader,
  ProposedAppointment,
} from '@/screens/velthuis/ProposedAppointment'
import { ProtectedRoute } from '@/screens/velthuis/ProtectedRoute.tsx'
import {
  loader as selectAppointmentTypeLoader,
  SelectAppointmentType,
} from '@/screens/velthuis/SelectAppointmentType'
import {
  action as selectCategoryAction,
  loader as selectCategoryLoader,
  SelectCategory,
} from '@/screens/velthuis/SelectCategory'
import {
  loader as selectClinicLoader,
  SelectClinic,
} from '@/screens/velthuis/SelectClinic'
import {
  loader as selectDateTimeLoader,
  SelectDateTime,
} from '@/screens/velthuis/SelectDateTime'
import {
  loader as selectSlotsLoader,
  SelectDoctor,
} from '@/screens/velthuis/SelectDoctor'
import { SuccessScreen } from '@/screens/velthuis/SuccessScreen.tsx'

export const router = [
  {
    children: [
      {
        action: savePatientDetailsAndCreateAppointmentAction,
        element: (
          <ProtectedRoute>
            <PatientDetails />
          </ProtectedRoute>
        ),
        path: 'appointment/patient-details',
      },
      {
        element: (
          <ProtectedRoute>
            <ConfirmBooking />
          </ProtectedRoute>
        ),
        path: 'appointment/:category/:appointmentType/:locationId/:doctorId/confirm-booking',
      },
      {
        element: <ProposedAppointment />,
        loader: proposedAppointmentLoader,
        path: 'appointment/:category/:appointmentType/:locationId/:doctorId/proposed-appointment',
      },
      {
        action: selectCategoryAction,
        element: <SelectCategory />,
        index: true,
        loader: selectCategoryLoader,
        path: '*',
      },
      {
        element: <SelectAppointmentType />,
        loader: selectAppointmentTypeLoader,
        path: 'appointment/:category',
      },
      {
        action: bmiCalculatorAction,
        element: <BMICalculator />,
        path: 'appointment/:category/:appointmentType/:locationId?/:doctorId?/bmi-calculator',
      },
      {
        element: <HealthWarning />,
        path: 'appointment/:category/:appointmentType/:locationId?/:doctorId?/health-warning',
      },
      {
        element: <BMIHigh />,
        path: 'appointment/:category/:appointmentType/:locationId?/:doctorId?/bmi-high/:bmi',
      },
      {
        element: <SelectClinic />,
        loader: selectClinicLoader,
        path: 'appointment/:category/:appointmentType',
      },
      {
        element: <SelectDoctor />,
        loader: selectSlotsLoader,
        path: 'appointment/:category/:appointmentType/:locationId',
      },
      {
        element: <SelectDateTime />,
        loader: selectDateTimeLoader,
        path: 'appointment/:category/:appointmentType/:locationId/:doctorId',
      },
      {
        element: (
          <ProtectedRoute>
            <SuccessScreen />
          </ProtectedRoute>
        ),
        path: 'success',
      },
      {
        element: (
          <ProtectedRoute requireSlot={false}>
            <ErrorScreen />
          </ProtectedRoute>
        ),
        path: 'error',
      },
    ],
    element: <App />,
    path: '*',
  },
]
